import restify from './restify';
import api from './api';

const service = {
  ...restify('user-access'),
  fetchPending: params => api.get('user-access/users/pending', params),
  approvePending: params => api.patch('user-access/approve', params),
  denyPending: params => api.patch('user-access/deny', params),
};

export default service;
